import React, { useEffect, useState } from 'react';
import { Image, Stack, Button } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import {
	useAcceptConnectionRequestMutation,
	useGetMyConnectionListQuery,
	useRemoveConnectRequestMutation,
} from 'services';
import { dataLimits, myConnectionUrl, S3_URL } from 'constants';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './styles.scss';
import useTranslate from 'hooks/useTranslate';

const ConnectionRequestBox: React.FC = () => {
	const location = useLocation();
	const userData = {
		currentPage: 1,
		limit: dataLimits.limits,
		order: 'DESC',
		connectionType: 'request',
		keyword: '',
	};
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const [update, setUpdate] = useState<boolean>(false);
	const { data: { docs = [] } = [], refetch }: any = useGetMyConnectionListQuery(userData);
	const { mutateAsync: acceptRequestMutation } = useAcceptConnectionRequestMutation();
	const { mutateAsync: rejectRequestMutation } = useRemoveConnectRequestMutation();

	useEffect(() => {
		refetch();
	}, [update]);

	const handleAcceptRequest = (id: any) => {
		acceptRequestMutation(id)
			.then((_res: any) => {
				setUpdate((prev) => !prev);
			})
			.catch((err: any) => {
				console.log(err);
			});
	};

	const handleRejectRequest = (id: any) => {
		rejectRequestMutation(id)
			.then((_res: any) => {
				setUpdate((prev) => !prev);
			})
			.catch((err: any) => {
				console.log(err);
			});
	};

	const gotToRequestPage = () => {
		navigate('/seeker/my-connections?activeTab=request&value=');
	};

	// when user already on my-connection page , we are hiding Requested Users Component in Sidebar
	if (myConnectionUrl.includes(location.pathname)) {
		return <></>;
	}
	if (docs?.length === 0) {
		return '';
	}
	return (
		<div className="connection-request white-box bg-white">
			<div className="heading d-flex align-items-center justify-content-between">
				<h5 className="fw-bold mb-0">{translate('Common.connectionRequest')}</h5>
				<Button onClick={gotToRequestPage} className="transparent-btn mb-0 rounded-pill lh-1">
					{translate('Common.seeMore')}
				</Button>
			</div>
			<Stack className="gap-3">
				{docs.length > 0 ? (
					docs?.map((res: any) => (
						<div
							key={`request-side-${res?.name}-${res?.userId}}`}
							className="connection-request-box d-flex"
						>
							<div className="profile-box rounded-circle">
								<Image
									src={`${S3_URL}${res?.profilePicture}`}
									onError={({ currentTarget }) => {
										currentTarget.onerror = null;
										currentTarget.src = IMAGE_PATHS.UserDefault;
									}}
									alt="img"
									className="w-100 h-100 rounded-circle object-fit-cover"
									loading="lazy"
								/>
							</div>
							<Stack className="people-detail flex-1 gap-2">
								<Link style={{ textDecoration: 'none' }} to={`/seeker/profile/${res?.userId}`}>
									<h6 className="fw-bold mb-0">{res?.name}</h6>
								</Link>
								<p className="mb-0">{res?.description}</p>
								<div className="d-flex gap-2">
									<Button
										onClick={() => handleAcceptRequest(res?.userId)}
										className="filled-btn rounded-pill lh-1"
									>
										{translate('Common.confirm')}
									</Button>
									<Button
										onClick={() => handleRejectRequest(res?.userId)}
										className="transparent-btn rounded-pill lh-1"
									>
										{translate('Common.delete')}
									</Button>
								</div>
							</Stack>
						</div>
					))
				) : (
					<Stack className="posted-job-box">
						<p className="mb-0">{translate('Common.noRequest')} </p>{' '}
					</Stack>
				)}
			</Stack>
		</div>
	);
};

export default ConnectionRequestBox;
